<template>
  <span class="anticon">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.37382 2.62886C7.62363 2.1706 8.37619 2.17058 8.62605 2.62886L10.2946 5.68579L13.3426 7.35656C13.5719 7.48194 13.714 7.72309 13.7142 7.98491L13.7075 8.08201C13.6772 8.30528 13.5433 8.50339 13.3426 8.61326L10.2946 10.2851L8.62605 13.341C8.50114 13.5707 8.2608 13.7137 7.99993 13.7137L7.90283 13.707C7.68042 13.6765 7.48298 13.5419 7.37382 13.341L5.70529 10.2851L2.6573 8.61326C2.42791 8.48766 2.28564 8.24669 2.28564 7.98491C2.28575 7.72309 2.42793 7.48194 2.6573 7.35656L5.70529 5.68579L7.37382 2.62886ZM7.00998 6.39785L6.80127 6.77955L6.41957 6.98825L4.60149 7.98491L6.41957 8.98268L6.80127 9.19139L7.99993 11.3878L9.19859 9.19139L9.58029 8.98268L11.3973 7.98491L9.58029 6.98825L9.19859 6.77955L8.98989 6.39785L7.99993 4.58199L7.00998 6.39785Z"
        fill="url(#paint0_linear_50_159563)" />
      <path
        d="M14.7061 2.59608L13.86 2.13165L13.3969 1.28251C13.2956 1.09593 12.9899 1.09593 12.8885 1.28251L12.4254 2.13165L11.5794 2.59608C11.4862 2.64724 11.4285 2.74508 11.4285 2.85128C11.4285 2.95764 11.4862 3.05547 11.5794 3.10646L12.4254 3.57078L12.8885 4.41992C12.9392 4.51322 13.0369 4.57115 13.1427 4.57115C13.2486 4.57115 13.3463 4.51322 13.3969 4.41992L13.8601 3.57078L14.7062 3.10646C14.7993 3.0555 14.857 2.95766 14.857 2.85128C14.857 2.74508 14.7993 2.64724 14.7061 2.59608Z"
        fill="url(#paint1_linear_50_159563)" />
      <path
        d="M4.42048 12.8812L3.57439 12.4168L3.11127 11.5677C3.00992 11.3811 2.70421 11.3811 2.60289 11.5677L2.1398 12.4168L1.29371 12.8812C1.20056 12.9324 1.14282 13.0302 1.14282 13.1364C1.14282 13.2428 1.20056 13.3406 1.29371 13.3916L2.1398 13.8559L2.60289 14.7051C2.65355 14.7984 2.75123 14.8563 2.85709 14.8563C2.96296 14.8563 3.06061 14.7984 3.1113 14.7051L3.57442 13.8559L4.42051 13.3916C4.51365 13.3407 4.57139 13.2428 4.57139 13.1364C4.57137 13.0302 4.51362 12.9324 4.42048 12.8812Z"
        fill="url(#paint2_linear_50_159563)" />
      <defs>
        <linearGradient id="paint0_linear_50_159563" x1="7.99993" y1="2.28516" x2="7.99993" y2="13.7137"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#762ECF" />
          <stop offset="1" stop-color="#D62FA0" />
        </linearGradient>
        <linearGradient id="paint1_linear_50_159563" x1="13.1428" y1="1.14258" x2="13.1428" y2="4.57115"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#762ECF" />
          <stop offset="1" stop-color="#D62FA0" />
        </linearGradient>
        <linearGradient id="paint2_linear_50_159563" x1="2.85711" y1="11.4277" x2="2.85711" y2="14.8563"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#762ECF" />
          <stop offset="1" stop-color="#D62FA0" />
        </linearGradient>
      </defs>
    </svg>
  </span>
</template>
<script>
export default {
  name: "BeexAIIcon",
};
</script>

<style lang="sass" scoped></style>
